import { checkboxAnatomy as parts } from '@chakra-ui/anatomy'
import type {
  PartsStyleObject,
  SystemStyleObject,
} from '@chakra-ui/theme-tools'

const baseStyleControl: SystemStyleObject = {
  w: '100%',
  transitionProperty: 'box-shadow',
  transitionDuration: 'normal',
  border: '1px solid',
  borderRadius: 'sm',
  borderColor: 'inherit',
  color: 'white',
  boxShadow: 'none !important',

  _checked: {
    bg: 'appBlue',
    borderColor: 'appBlue',
    color: 'appWhite',

    _hover: {
      bg: 'appBlue',
      borderColor: 'appBlue',
    },

    _disabled: {
      borderColor: 'appPaleBlue',
      bg: 'appPaleBlue',
      color: 'appWhite',
    },
  },

  _indeterminate: {
    bg: 'appBlue',
    borderColor: 'appPaleBlue',
    color: 'appWhite',
  },

  _disabled: {
    bg: 'appPaleBlue',
    borderColor: 'appPaleBlue',
  },

  _focus: {
    boxShadow: 'outline',
  },

  _invalid: {
    borderColor: 'appWatermelon',
  },
}

const baseStyleLabel: SystemStyleObject = {
  userSelect: 'none',
  fontWeight: '500',
  color: 'appSlate',
  textAlign: 'left',
  _disabled: { opacity: 0.4 },
}

const baseStyleIcon: SystemStyleObject = {
  transitionProperty: 'transform',
  transitionDuration: 'normal',
}

const baseStyle: PartsStyleObject<typeof parts> = {
  icon: baseStyleIcon,
  control: baseStyleControl,
  label: baseStyleLabel,
}

const sizes: Record<string, PartsStyleObject<typeof parts>> = {
  sm: {
    control: { h: 3, w: 3 },
    label: { fontSize: 'sm' },
    icon: { fontSize: '0.45rem' },
  },
  md: {
    control: { w: 4, h: 4 },
    label: { fontSize: 'md' },
    icon: { fontSize: '0.625rem' },
  },
  lg: {
    control: { w: 5, h: 5 },
    label: { fontSize: 'lg' },
    icon: { fontSize: '0.625rem' },
  },
}

const defaultProps = {
  size: 'md',
  colorScheme: 'blue',
}

export default {
  parts: parts.keys,
  baseStyle,
  sizes,
  defaultProps,
}
